import { render, staticRenderFns } from "./TransportCreateDialog.vue?vue&type=template&id=c3328f1e"
import script from "./TransportCreateDialog.vue?vue&type=script&lang=ts"
export * from "./TransportCreateDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports